import { render, staticRenderFns } from "./MusicLibraryWindow.vue?vue&type=template&id=05c3fef4&scoped=true&"
import script from "./MusicLibraryWindow.vue?vue&type=script&lang=ts&"
export * from "./MusicLibraryWindow.vue?vue&type=script&lang=ts&"
import style0 from "./MusicLibraryWindow.vue?vue&type=style&index=0&id=05c3fef4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c3fef4",
  null
  
)

export default component.exports